import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useState } from 'react'
import { InputDate } from '../../../../Forms/InputDate'
import { Button } from '../../../../Button'
import moment from 'moment'
import { toast } from 'react-toastify'
import { FaCheck } from 'react-icons/fa'
import { useDispatch } from 'react-redux'

import { Container, DateTimeInputs, ContentButtons, ButtonDate } from './style'


const listDateButtons = ['Hoje', 'Ontem', 'Mês atual', 'Últimos 7 dias', 'Últimos 15 dias', 'Últimos 30 dias', 'Últimos 90 dias', 'Personalizado']


export function PeriodFilter() {
    const {   
        startDate, setStartDate,
        endDate, setEndDate,
        typeDateSelected, setTypeDateSelected
    } = useAdministrativeContext()
    const dispatch = useDispatch()
    
    const [initialDateFilter, setInitialDateFilter] = useState(startDate)
    const [finalDateFilter, setFinalDateFilter] = useState(endDate)
    const [buttonDateSelected, setButtonDateSelected] = useState(typeDateSelected)

    function handleSetDateToFilter() {
        if(moment(initialDateFilter.slice(0, 10), 'YYYY-MM-DD', true).isValid() && moment(finalDateFilter.slice(0, 10), 'YYYY-MM-DD', true).isValid()){
            setStartDate(initialDateFilter)
            setEndDate(finalDateFilter)
            setTypeDateSelected(buttonDateSelected)
            dispatch({type: '', title: 'Filtrar período' })
        }else{
            toast.warning('Insira uma data válida')
        }
    }


    function handleSetToday() {
        const date = new Date()

        setInitialDateFilter(moment(date).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(date).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(0)
    }

    function handleSetYesterday() {
        const date = new Date()
        const dateAdjusted = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)

        setInitialDateFilter(moment(dateAdjusted).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(dateAdjusted).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(1)
    }

    function handleSetCurrentMonth() {
        const date = new Date()
        const start = new Date(date.getFullYear(), date.getMonth(), 1)

        setInitialDateFilter(moment(start).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(date).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(2)
    }

    function handleSetLastNinetyDays() {
        const date = new Date()
        const start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 90)

        setInitialDateFilter(moment(start).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(date).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(6)
    }

    function handleSetLastThirtyDays() {
        const date = new Date()
        const start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30)

        setInitialDateFilter(moment(start).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(date).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(5)
    }

    function handleSetLastFifteenDays() {
        const date = new Date()
        const start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 15)

        setInitialDateFilter(moment(start).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(date).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(4)
    }

    function handleSetLastSevenDays() {
        const date = new Date()
        const start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7)

        setInitialDateFilter(moment(start).format("YYYY-MM-DD") + "T00:00:00")
        setFinalDateFilter(moment(date).format("YYYY-MM-DD") + "T23:59:59")
        setButtonDateSelected(3)
    }

    function setterDateManager(index) {
        switch(index){
            case 0:
                return handleSetToday()
            case 1:
                return handleSetYesterday()
            case 2:
                return handleSetCurrentMonth()
            case 3:
                return handleSetLastSevenDays() 
            case 4:
                return handleSetLastFifteenDays() 
            case 5:
                return handleSetLastThirtyDays()
            case 6:
                return handleSetLastNinetyDays()
            default:
                return
        }
    }


    return(
        <Container>

            <div className='chooseDate'>
                <ContentButtons>
                    {
                        listDateButtons.map((button, index) => (
                            <ButtonDate 
                                key={index}
                                onClick={() => setterDateManager(index)}
                                selected={buttonDateSelected === index}
                            >
                                <p>{button}</p>
                                {buttonDateSelected === index && <FaCheck />}
                            </ButtonDate>
                        ))
                    }
                </ContentButtons>


                <DateTimeInputs>
                    <InputDate 
                        type="datetime-local"
                        value={initialDateFilter}
                        onChange={event => {
                            setInitialDateFilter(event.target.value)
                            setButtonDateSelected(7)
                        }}
                    />
                    <p>a</p>
                    <InputDate 
                        type="datetime-local"
                        value={finalDateFilter}
                        onChange={event => {
                            setFinalDateFilter(event.target.value)
                            setButtonDateSelected(7)
                        }}
                    />
                </DateTimeInputs>
            </div>


            <Button
                background="#7A05A7"
                color="#FFF"
                onClick={handleSetDateToFilter}
            >
                Aplicar
            </Button>
        </Container>
    )
}
